'use es6';

export const queryParamTermSelector = ({
  queryParamTerm
}) => queryParamTerm;